module.exports = __webpack_public_path__ + "img/groupfarmer.7bd95095.png";